import React, { useContext } from 'react';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType, isLegacyStatus } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import { ActionBarProps as Props } from '../../types';
import DesktopActionBar from '../../variants/DesktopActionBar';
import MobileActionBar from '../../variants/MobileActionBar';
import ExpandActionBar from '../../variants/ExpandActionBar';
import SimpleActionBar from '../../variants/SimpleActionBar';
import CommissionActionBar from '../../variants/CommissionActionBar';
import TierActionBar from '../../variants/TierActionBar';
import StashActionBar from '../../variants/StashActionBar';

const ActionBarContent: React.FC<Props> = props => {
  const { isFullscreen } = useDeviationViewContext();
  const isMobile = useContext(MobileContext);

  const { deviation } = props;
  const deviationType = getDeviationType(deviation);

  if (!deviation.isPublished) {
    return <StashActionBar {...props} />;
  }

  if (isFullscreen) {
    return <ExpandActionBar {...props} />;
  }

  if (isMobile) {
    return <MobileActionBar {...props} />;
  }

  if (deviationType === DeviationTypes.STATUS && !isLegacyStatus(deviation)) {
    return <DesktopActionBar {...props} />;
  }

  switch (deviationType) {
    case DeviationTypes.STATUS:
    case DeviationTypes.POLL:
      return <SimpleActionBar {...props} />;
    case DeviationTypes.COMMISSION:
      return <CommissionActionBar {...props} />;
    case DeviationTypes.TIER:
      return <TierActionBar {...props} />;
    default:
      return <DesktopActionBar {...props} />;
  }
};
ActionBarContent.displayName = 'ActionBarContent';

export default ActionBarContent;
